import React, { useState } from "react";
import "./LoginPage.css"; // import css
// import BASE_URL from '../../config';
import { useNavigate } from "react-router-dom";
import {
  BASE_URL,
  LOGIN_URL
} from "../../constants/Apis";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   // call your login API here
  //   console.log("Login details:", { email, password });

  //   // example:
  //   fetch(`${BASE_URL}/api/login`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ email, password }),
  //   })
  //     .then(res => res.json())
  //     .then(data => { 
  //       console.log("Login success:", data)
  //       localStorage.setItem("token", data.token);
  //   })
  //     .catch(err => console.error("Login failed:", err));
  // };

  const handleSubmit = (e) => {
    e.preventDefault(); // prevent page reload
    handleLogin(email, password); // call your login function here
  };

  const handleLogin = async (email, password) => {
  const response = await fetch(`${BASE_URL}${LOGIN_URL}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  const data = await response.json();
  if (data.status === "success") {
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));
    navigate("/admin/dashboard");
  } else {
    alert(data.message || "Login failed");
  }
};


  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2 className="login-title">Login</h2>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="login-btn">Login</button>
      </form>
    </div>
  );
}
